var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-md-6 mb-4"},[_c('div',{staticClass:"card h-100"},[_c('div',{staticClass:"card-body d-flex align-items-center"},[_c('div',{staticClass:"flex-grow-1"},[_vm._v(_vm._s(_vm.item.label))]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-primary ml-2 float-right",attrs:{"to":{name: 'QuestionShowByPack', params: { packId: _vm.item.id }}}},[_vm._v(_vm._s(_vm.$t('packs.list.play')))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e1136cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pack/Card.vue
// module id = 1060
// module chunks = 0